import {
  Button,
  Checkbox,
  CircularProgress,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { MinusCircleIcon, SelectArrowDownIcon } from '@room-match/shared-ui-components';
import React, { useEffect, useState } from 'react';
import { COLORS } from 'shared/constants/COLORS';
import { IAgency, IAgencyAccessCodeParams } from 'shared/interfaces/utils/IAgency';
import { agencyService } from 'shared/services/agencyService';
import { useStyles } from './chip.styles';

interface Props {
  bypassCode?: boolean;
  agency: { id: string; type: string; attributes: IAgency };
  handleRemoveRepresentative: (id: string) => void;
  setRepresentatives(
    representatives: Array<{
      id: string;
      type: string;
      attributes: IAgency;
    }>,
  ): void;
  representatives: Array<{
    id: string;
    type: string;
    attributes: IAgency;
  }>;
}

const { validateAgencyCode } = agencyService();

const RepresentationChip: React.FC<Props> = ({
  agency,
  handleRemoveRepresentative,
  setRepresentatives,
  representatives,
  bypassCode,
}) => {
  const { required_access_code, full_name, name, divisions, access_code, selected_divisions } =
    agency?.attributes || {};
  const [selectedDivisions, setselectedDivisions] = useState<string[]>(selected_divisions || []);
  const { chips, acessCodeCont, name: nameStyle, wrapper } = useStyles();
  const [showCodeModal, setshowCodeModal] = useState(false);
  const [code, setcode] = useState(access_code || '');
  const [codeCorrect, setcodeCorrect] = useState(!required_access_code || bypassCode);
  const [invalidCode, setinvalidCode] = useState(false);

  const [agencyCode, setagencyCode] = useState<IAgencyAccessCodeParams>({
    agency_access_code: '',
    agency_id: '',
  });

  const { data, isLoading } = validateAgencyCode(agencyCode);

  const handleClick = () => {
    if (required_access_code) {
      setshowCodeModal(true);
    }
  };

  const processCode = () => {
    setcodeCorrect(true);
    const newRepresentatives = [
      ...representatives.map((rep) => {
        if (rep.id === agency.id) {
          return { ...rep, attributes: { ...rep.attributes, access_code: code } };
        }
        return rep;
      }),
    ];
    setRepresentatives(newRepresentatives);
    setshowCodeModal(false);
  };

  useEffect(() => {
    if (data) {
      if ((data as any).valid) {
        processCode();
      } else {
        setinvalidCode(true);
        setcode('');
      }
    }
  }, [data]);

  // const handleOnSubmit = (e: any, c: string) => {
  //   e.stopPropagation();
  //   setcode(c);
  //   //alter representatives array by adding the code to the agency
  //   const newRepresentatives = [
  //     ...representatives.map((rep) => {
  //       if (rep.id === agency.id) {
  //         return { ...rep, attributes: { ...rep.attributes, access_code: c } };
  //       }
  //       return rep;
  //     }),
  //   ];
  //   setRepresentatives(newRepresentatives);
  //   setshowCodeModal(false);
  // };

  const MenuProps = {
    PaperProps: {
      style: {
        minWidth: 200,
      },
    },
  };

  const updateRepresentatives = (divisions: string[]) => {
    const newRepresentatives = [
      ...representatives.map((rep) => {
        if (rep.id === agency.id) {
          return { ...rep, attributes: { ...rep.attributes, selected_divisions: divisions } };
        }
        return rep;
      }),
    ];

    console.log('newRepresentatives', newRepresentatives);

    setRepresentatives(newRepresentatives);
  };

  const handleDivisionChange = (event: any) => {
    const {
      target: { value },
    } = event;

    if (Array.isArray(value)) {
      const index = value.indexOf('Any');
      if (index > -1) {
        value.splice(index, 1);
      }
    }

    if (value.indexOf('any') > -1) {
      setselectedDivisions(['any']);
      updateRepresentatives(['any']);
    } else {
      updateRepresentatives(value);
      setselectedDivisions(value);
    }
  };

  const verifyCode = async () => {
    setagencyCode({
      agency_access_code: code,
      agency_id: agency.id,
    });
  };

  const error = (bypassCode ? false : required_access_code && !code) || (divisions.length && !selectedDivisions.length);
  return (
    <div
      className={chips}
      style={{
        border: `solid 1px ${error ? '#d83032' : 'transparent'}`,
      }}
    >
      {/* <StyledTooltip
        disableHoverListener={!required_access_code}
        title={'Click to enter the code provided by your agency in order to add representation with this company.'}
      > */}
      <div className={wrapper}>
        <Typography className={nameStyle}>{full_name || name}</Typography>
        {/* {required_access_code ? (
          <IconButton disableRipple style={{ padding: 5, marginLeft: 'auto' }}>
            <CiLock fontSize={24} color={codeCorrect ? COLORS.SUCCESS : '#d83032'} />
          </IconButton>
        ) : (
          <React.Fragment />
        )} */}
        <IconButton
          disabled={bypassCode}
          style={{ padding: 5, marginLeft: 5, marginRight: -5, opacity: bypassCode ? 0 : 1 }}
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveRepresentative(agency.id);
          }}
        >
          <MinusCircleIcon />
        </IconButton>
        {/* {showCodeModal && (
          <CodeModal
            showCodeModal={showCodeModal}
            close={() => setshowCodeModal(false)}
            agencyName={name}
            code={code}
            onSubmit={handleOnSubmit}
          />
        )} */}
      </div>
      {/* </StyledTooltip> */}

      {!codeCorrect && !bypassCode && (
        <>
          <TextField
            placeholder={!code.length && invalidCode ? 'Invalid Code' : 'Access Code'}
            variant="outlined"
            style={{ margin: 0, background: 'red !important', border: 'none' }}
            value={code}
            onChange={(e) => setcode(e.target.value)}
            InputProps={{
              style: {
                fontWeight: 800,
                background: COLORS.DARK_GRAY,
                color: !code.length && invalidCode ? COLORS.DANGER : 'white',
              },
              endAdornment: (
                <Button
                  variant="contained"
                  style={{
                    opacity: !code.length || isLoading ? 0.5 : 1,
                    background: code.length ? COLORS.PRIMARY : COLORS.DARK_GRAY,
                    color: 'white',
                    border: `solid 2px ${COLORS.DARK_BORDER}`,
                  }}
                  disabled={!code.length || isLoading}
                  onClick={verifyCode}
                >
                  {isLoading ? <CircularProgress size={20} style={{ color: 'white' }} /> : 'Verify'}
                </Button>
              ),
            }}
          />
        </>
      )}
      {(!required_access_code || bypassCode || codeCorrect) && divisions.length ? (
        <Select
          style={{ height: 50, background: COLORS.DARK_GRAY, paddingLeft: 10, border: 'none' }}
          MenuProps={MenuProps}
          IconComponent={SelectArrowDownIcon}
          variant="outlined"
          fullWidth
          multiple
          onChange={handleDivisionChange}
          startAdornment={
            <InputAdornment
              style={{ color: `${COLORS.PRIMARY} !important`, background: COLORS.DARK_GRAY }}
              position="start"
            >
              Division:
            </InputAdornment>
          }
          value={selectedDivisions?.length > 0 ? selectedDivisions : []}
          renderValue={(selected: any) =>
            // selected.length > 1 ? `${selected.length} Selected` : selected[0] === 'All' ? 'All' : '1 Selected'
            selected.length > 1
              ? `${divisions.find((f) => f.id === selected[0])?.name} +${selected.length - 1}`
              : selected[0] === 'any'
                ? 'Any'
                : `${divisions.find((f) => f.id === selected[0])?.name}`
          }
          // error={!selectedDivisions.length}
        >
          <MenuItem key={'any'} value={'any'}>
            <Checkbox checked={selectedDivisions.indexOf('any') > -1} color="primary" />
            <ListItemText primary={'Any'} style={{ textTransform: 'capitalize' }} />
          </MenuItem>
          {divisions.map((r) => (
            <MenuItem key={r.id} value={r.id} disabled={selectedDivisions.indexOf('any') > -1}>
              <Checkbox checked={selectedDivisions.indexOf(r.id) > -1} color="primary" />
              <ListItemText primary={r.name} style={{ textTransform: 'capitalize' }} />
            </MenuItem>
          ))}
        </Select>
      ) : (
        <React.Fragment />
      )}
    </div>
  );
};

export default RepresentationChip;
